import logger from "./logger"

const STATUS_RUNNING = "running",
  STATUS_COMPLETED = "completed"

const DEFAULT_IDLE_TIMEOUT = 10000 // Timeout d'inactivté
const DEFAULT_ELAPSE_TIMEOUT = 10 * DEFAULT_IDLE_TIMEOUT // Timeout global
let REQID = 0

class WS {
  url: string
  method: string
  body: ?{ [string]: any }
  useCredentials: boolean //Attention: oui par déaut
  tokenType: "graph" | "server"

  constructor(url: string) {
    // l'url a appeler
    this.url = url
    // get ou post
    this.method = ""
    // Si post, contenu à poster
    this.body = null
    // Si on doit utiliser le token azure
    this.useCredentials = true
    this.tokenType = "server"
  }
  get() {
    this.method = "GET"
    this.body = null
    return this
  }
  post(body: Object) {
    this.method = "POST"
    this.body = body
    return this
  }
  put(body: Object) {
    this.method = "PUT"
    this.body = body
    return this
  }
  delete(body?: Object) {
    this.method = "DELETE"
    this.body = body
    return this
  }
  setMode(name: "graph" | "server") {
    this.tokenType = name
    return this
  }
  noCredentials() {
    // Desactive l'utilisation du token azure pour cette requete
    this.useCredentials = false
    return this
  }

  execute(): Promise<*> {
    // Eventuellement, remplacer cette promise par quelque chose qui va récupérer/renouveler des credentials
    return Promise.resolve().then(accessToken => {
      const reqId = REQID++
      let body
      if (this.body !== null && this.body) {
        body = JSON.stringify(this.body)
      }
      try {
        const progress = {
          lastEvent: Date.now(),
          status: STATUS_RUNNING
        }
        let xhr
        const promises = []
        // La requete
        promises[promises.length] = new Promise((accept, reject) => {
          xhr = new XMLHttpRequest()
          xhr.onprogress = e => {
            progress.lastEvent = Date.now()
          }
          xhr.onerror = e => {
            progress.status = STATUS_COMPLETED
            reject(e)
          }
          xhr.onload = e => {
            progress.status = STATUS_COMPLETED
            accept({
              status: xhr.status,
              //$FlowFixMe
              json: () => JSON.parse(e.target.responseText),
              //$FlowFixMe
              text: () => e.target.responseText,
              getResponseHeader: h => xhr.getResponseHeader(h)
            })
          }
          xhr.onloadend = () => {
            if (progress.status === STATUS_RUNNING) {
              progress.status = STATUS_COMPLETED
              reject("Unknown error. Timeout ?")
            }
          }
          xhr.open(this.method, this.url, true)
          xhr.timeout = DEFAULT_ELAPSE_TIMEOUT // Sur IE11, le timeout doit etre affecté APRES open()
          if (this.body) {
            xhr.setRequestHeader("Content-Type", "application/json")
          }
          xhr.send(body)
        })

        // Le timeout
        promises[promises.length] = new Promise((resolve, reject) => {
          const triggerTimeout = () =>
            setTimeout(() => {
              // On verifie regulierement que c'est terminé ou pas.
              if (progress.status === STATUS_RUNNING) {
                if (
                  Date.now() > progress.lastEvent &&
                  progress.lastEvent > DEFAULT_IDLE_TIMEOUT
                ) {
                  logger.debug(
                    "req[" +
                      reqId +
                      "] Timeout (" +
                      DEFAULT_IDLE_TIMEOUT +
                      ") for " +
                      this.url +
                      ". Cancelling."
                  )
                  progress.status = STATUS_COMPLETED
                  if (xhr) {
                    try {
                      xhr.abort()
                    } catch (e) {
                      logger.error("ERROR WHILE ABORT", e)
                    }
                  }
                  reject("errors time out")
                  return
                } else {
                  // Wait more
                  triggerTimeout()
                }
              }
            }, 5000)
          triggerTimeout()
        })

        const startTimestamp = Date.now()
        return Promise.race(promises)
          .then(response => {
            progress.status = STATUS_COMPLETED
            logger.debug(
              "req[" +
                reqId +
                "] got answer from server in " +
                (Date.now() - startTimestamp) +
                "ms for url=" +
                this.url +
                ". status=" +
                response.status
            )
            if (
              response.status !== 200 &&
              response.status !== 204 &&
              response.status !== 201
            ) {
              throw new Error("Code retour : " + response.status)
            }

            if (response.status === 200 || response.status === 201) {
              return response.json()
            } else if (response.status === 204) {
              return { status: 204, data: null }
            } else {
              return null
            }
          })
          .then(json => {
            if (!json) {
              throw new Error("No data")
            }
            return json
          })
          .catch(error => {
            progress.status = STATUS_COMPLETED
            logger.error(
              "req[" + reqId + "] Error while accessing " + this.url + " : ",
              error
            )
            throw error
          })
      } catch (error) {
        return Promise.reject(error)
      }
    })
  }
}

export default WS



// WEBPACK FOOTER //
// ./src/utils/ws.js